import { ApiResponse, getData, postJson } from './Apis';

export type JobAlertInfoModel = {
    ExplicitConsentExpiration: Date,
    Feature_DataRetention: boolean,
    JobCategoriesRowVisible: boolean,
    JobTitlesRowVisible: boolean,
    LocationsRowVisible: boolean,
    DepartmentsRowVisible: boolean,
    FunctionsRowVisible: boolean,
    CanView: boolean,
    Feature_EmailVerification: boolean,
    EmailVerified: boolean,
    Departments: JobAlert_DepartmentDataModel[],
    Categories: JobAlert_CategoriesDataModel[],
    Functions: JobAlert_FunctionsDataModel[],
    Titles: JobAlert_TitlesDataModel[],
    Cities: JobAlert_CitiesDataModel[],
}

export type JobAlertInfoPostModel = {
    Departments: JobAlert_DepartmentDataModel[],
    Categories: JobAlert_CategoriesDataModel[],
    Functions: JobAlert_FunctionsDataModel[],
    Titles: JobAlert_TitlesDataModel[],
    Cities: JobAlert_CitiesDataModel[],
}

export type JobAlert_DepartmentDataModel = {
    DepartmentRef: number,
    Department: string,
    Selected: boolean,
}

export type JobAlert_CategoriesDataModel = {
    CategoryCode: string,
    Category: string,
    Selected: boolean,
}

export type JobAlert_FunctionsDataModel = {
    JobFunctionRef: number,
    JobFunction: string,
    Selected: boolean,
}

export type JobAlert_TitlesDataModel = {
    JobtitleRef: number,
    Jobtitle: string,
    Selected: boolean,
}

export type JobAlert_CitiesDataModel = {
    LocationAltText: string,
    City: string,
    Selected: boolean,
}

export async function API_JobAlerts(): Promise<ApiResponse<JobAlertInfoModel>> {
    return await getData<ApiResponse<JobAlertInfoModel>>(`webapi/candidate/JobAlerts/GetDetails`);
}

export async function API_UpdateJobAlerts(data: JobAlertInfoPostModel): Promise<ApiResponse<string>> {
    return await postJson<ApiResponse<string>>(`webapi/candidate/JobAlerts/Update`, data);
}

export async function API_UnsubscribeJobAlerts(username: string) {
    const tokens: NodeListOf<HTMLInputElement> = document.getElementsByName('__RequestVerificationToken') as any;
    const token = tokens && tokens.length ? tokens[0].value : '';
    return await fetch(`${window.location.origin}/webapi/candidate/JobAlerts/Unsubscribe?username=${username}`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
            'Accepts': 'application/json',
            '__RequestVerificationToken': token,
        }
    });
}